import { findBuById, findSiteById } from '../data/master/businessUnits';
import { STAFF_SCOPE_TYPES } from '../data/staff/permissions';

export function scopeTypeLabel(scopeType) {
  return STAFF_SCOPE_TYPES.find((s) => s.value === scopeType)?.label || scopeType || '—';
}

export function formatStaffScope(staff, businessUnits, sites) {
  if (!staff) return '—';
  if (staff.scopeType === 'all') return 'All';
  const bu = findBuById(businessUnits, staff.buId);
  if (staff.scopeType === 'bu') {
    return bu?.shortName ? `${bu.shortName} (all sites)` : staff.buId || '—';
  }
  if (staff.scopeType === 'bu_site') {
    const site = findSiteById(sites, staff.siteId);
    const buLabel = bu?.shortName || staff.buId;
    const siteLabel = site?.siteName || staff.siteId;
    return [buLabel, siteLabel].filter(Boolean).join(' · ') || '—';
  }
  return '—';
}
